import { type BudgetPeriod, isBudgetPeriod, whyItStopped } from "@rally/agreed";
import { Col, Icon, Text, useTheme } from "@rally/ui-kit";
import { say } from "../../localization/say.ts";
import { calledBy } from "../../me/called.ts";
import type { Person } from "../composer/saying.ts";
import type { Stop } from "../person/arrivals.ts";

export function Stopped({
  stop,
  by,
  known,
}: {
  stop: Stop;

  by: string;
  known: Map<string, Person>;
}) {
  const theme = useTheme();
  const somebody = say("chat.someone");

  const agent = calledBy(known.get(stop.agent ?? "")) ?? somebody;
  const period: BudgetPeriod | null = isBudgetPeriod(stop.period ?? "")
    ? (stop.period as BudgetPeriod)
    : null;
  const said = whyItStopped(
    { how: stop.how, period, by: stop.how === "halted" ? (calledBy(known.get(by)) ?? somebody) : null },
    agent,
  );
  return (
    <Col
      testID="record-stopped"
      style={{
        flexDirection: "row",
        alignItems: "flex-start",
        gap: theme.space[2],

        paddingLeft: theme.space[2],
      }}
    >
      <Col style={{ paddingTop: theme.space[1] }}>
        <Icon name="stop" size={14} color="text.tertiary" />
      </Col>
      <Col style={{ flex: 1, gap: theme.space[1] }}>
        <Text typeName="caption" color="text.secondary">
          {said}
        </Text>
        {stop.why ? (
          <Text typeName="caption" color="text.tertiary" testID="record-stopped-why">
            {stop.why}
          </Text>
        ) : null}
      </Col>
    </Col>
  );
}
